// Pages
export const HOME_PAGE_URL = '/';
export const CONTACT_PAGE_URL = '/contact';
export const ABOUT_PAGE_URL = '/about-me';
export const EXTRA_LINKS_URL = '/extra-links';
export const CLIPS_FANSITES_PAGE_URL = '/clips-fansites';
export const REAL_TIME_URL = '/sessions/real-time';
export const RATES_AND_TRIBUTES_URL = '/sessions/rates-and-tributes';
export const ONLINE_SESSIONS_URL = '/sessions/online-sessions';
export const DUNGEON_SESSIONS_URL = '/sessions/dungeon-sessions';
export const GALLERY_PAGE_URL = '/gallery';
export const FAQS_PAGE_URL = '/faqs';

// Terms and Conditions
export const POLICIES_PAGE_URL = '/user-agreements';

// Maintainance
export const MAINTENANCE_PAGE_URL = '/down-for-maintenance';

// Error
export const ERROR_404_PAGE_URL = '*';

// User pages
export const SIGN_UP_PAGE_URL = '/sign-up';
export const LOGIN_PAGE_URL = '/login';
export const VERIFY_EMAIL_PAGE_URL = '/verify-email-address';
export const RESET_PASS_PAGE_URL = '/reset-password';

// Admin pages
export const ADMIN_PAGE_URL = '/admin';
export const ADMIN_CONTACT_FORM_PAGE_URL = '/admin/contact-forms';
export const ADMIN_CALLBACK_FORM_PAGE_URL = '/admin/callback-forms';

// Blog routes
export const BLOG_PAGE_URL = '/blog';
export const BLOG_POST_PAGE_URL = '/blog';
export const CREATE_BLOG_POST_PAGE_URL = '/blog/create-new-post';
export const EDIT_BLOG_POST_PAGE_URL = '/blog/edit/postId';

// Booking routes
export const BOOKING_PAGE_URL = '/booking';
export const BOOKING_ADMIN_PAGE_URL = '/admin/booking-admin';

// Newsletter routes
export const NEWSLETTER_PAGE_URL = '/newsletter';
export const NEWSLETTER_CONFIRM_EMAIL_PAGE_URL = '/newsletter/confirm-email';
export const NEWSLETTER_UNSUBSCRIBE_PAGE_URL = '/newsletter/unsubscribe';
export const NEWSLETTER_ADMIN_PAGE_URL = '/admin/newsletter-overview';